import { render, staticRenderFns } from "./HistogramChart.vue?vue&type=template&id=9f7fc968&scoped=true"
import script from "./HistogramChart.vue?vue&type=script&lang=ts"
export * from "./HistogramChart.vue?vue&type=script&lang=ts"
import style0 from "./HistogramChart.vue?vue&type=style&index=0&id=9f7fc968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7fc968",
  null
  
)

export default component.exports